module.exports = __webpack_public_path__ + "static/img/logo-ges-black.60cb269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-ges-black.png
// module id = Pnnm
// module chunks = 1